import React from "react";
import type { ViewComponent } from "@frui.ts/views";
import AccountingDocumentCandidateRowsViewModel from "viewModels/finance/accountingDocumentsApprovals/accountingDocumentCandidateRowsViewModel";
import { observer } from "mobx-react-lite";
import ListView from "../../common/list";
import type { ColumnDefinition } from "@frui.ts/dataviews/dist/dataTypes";
import type AccountingDocumentCandidateRowResponse from "entities/accountingDocumentCandidateRowResponse";
import { registerView } from "@frui.ts/views";
import { formatAmount } from "utils/localizations";
import { emptyValue } from "utils/emptyValue";

export const AccountingDocumentCandidateRowsView: ViewComponent<AccountingDocumentCandidateRowsViewModel> = observer(({ vm }) => {
  const columns: ColumnDefinition<AccountingDocumentCandidateRowResponse>[] = [
    {
      title: vm.translateAttribute("rowOrder"),
      property: "rowOrder",
    },
    {
      title: vm.translateAttribute("credit"),
      property: "credit",
      valueFormatter: props => formatAmount(props.value),
    },
    {
      title: vm.translateAttribute("debit"),
      property: "debit",
      valueFormatter: props => formatAmount(props.value),
    },
    {
      title: vm.translateAttribute("syntheticAccount"),
      property: "syntheticAccount",
    },
    {
      title: vm.translateAttribute("analyticAccount"),
      property: "analyticAccount",
    },
    {
      title: vm.translateAttribute("paragraph"),
      property: "paragraph",
      valueFormatter: props => props.value ?? emptyValue,
    },
    {
      title: vm.translateAttribute("article"),
      property: "article",
      valueFormatter: props => props.value ?? emptyValue,
    },
    {
      title: vm.translateAttribute("papAnalyticBreakdown"),
      property: "papAnalyticBreakdown",
    },
    {
      title: vm.translateAttribute("papTransaction"),
      property: "papTransaction",
      valueFormatter: props => props.value ?? emptyValue,
    },
    {
      title: vm.translateAttribute("documentRowDescription"),
      property: "documentRowDescription",
    },
    {
      title: vm.translateAttribute("partnerBalance"),
      property: "partnerBalance",
    },
  ];

  return <ListView columns={columns} vm={vm} hideTitle={true} />;
});

registerView(AccountingDocumentCandidateRowsView, AccountingDocumentCandidateRowsViewModel);
